<script>
import DialogHeader from "../../../dialog/components/dialog-header.vue";
import DialogActionbar from "../../../dialog/components/dialog-actionbar.vue";
import DialogBody from "../../../dialog/components/dialog-body.vue";
import Dropzone from "../../../content/mediapool/add/dropzone.vue";
import DialogBase from "../../../dialog/components/dialog-base.vue";
import DialogButton from "../../../dialog/components/dialog-button.vue";

export default {
    name: 'myuser-file-upload',
    components: {DialogButton, DialogBase, Dropzone, DialogBody, DialogActionbar, DialogHeader},
    props: {
        id: {
            type: String,
            required: true
        },
        showDialog: {
            type: Boolean
        },
        picture: {
            type: String
        },
    },
    data() {
        return {
            cropping: false,
            image: {
                file: '',
                width: '',
                height: '',
                x: '',
                y: '',
                original: ''
            },
            tEditImage: Lang.langGet('Edit profile image'),
            tUploadImage: Lang.langGet('Upload image'),
        }
    },
    methods: {
        handleUpload() {
            this.image = {};
            this.cropping = false;
        },
        handleClose() {
            this.image = {};
            this.cropping = false;
            this.$emit('close');
        },
        handleSave(){
            this.$emit('save', this.image)
            this.$emit('close');
        },
        initializeCropper() {
            const image = $(`#${this.id} .cropper > img`);
            const inputImage = $(`#${this.id} input[name='file']`);

            $(image).cropper({
                aspectRatio: 1,
                autoCropArea: 0.8,
                minContainerHeight: 480,
                minContainerWidth: 480,
                minCropBoxWidth: 240,
                minCropBoxHeight: 240,
                crop: event => {
                    this.image.height = event.detail.height;
                    this.image.width = event.detail.width;
                    this.image.x = event.detail.x;
                    this.image.y = event.detail.y;
                },
            });

            if (window.FileReader) {
                inputImage.change((element) => {
                    const fileReader = new FileReader();

                    const files = element.target.files;
                    if (!files.length) return;

                    const file = files[0];

                    if (!/^image\/\w+$/.test(file.type)) return;

                    this.cropping = true;

                    fileReader.readAsDataURL(file);
                    fileReader.onload = () => {
                        inputImage.val("");
                        image.cropper("reset", true).cropper("replace", fileReader.result);
                        this.image.original = fileReader.result;
                    };
                });
            }
        },
    },
    updated() {
        if (this.showDialog) {
            this.initializeCropper();
        }
    },
    computed: {
        currentSrc() {
            if (!this.picture) return '/img/avatar.png';
            return `/storage/mediapool/profile_images/${this.picture}`;
        }
    }
}
</script>

<template>
    <dialog-base
        class="mx-3"
        :maxWidth="720"
        :showDialog="showDialog"
        @close="handleClose"
    >
        <v-card>
            <dialog-header
                :title="tEditImage"
                @close="handleClose"
            />
            <dialog-body>
                <div :id="id" class="ma-1">
                    <div :class="[(cropping ? '' : 'hidden'), 'cropper form-group ma-8']">
                        <img :alt="'new picture'" :src="image.file"/>
                    </div>
                    <div v-if="!cropping" :class="'d-flex justify-center ma-8'">
                        <img :alt="'placeholder'" :src="currentSrc"/>
                    </div>
                </div>
            </dialog-body>
            <dialog-actionbar
                @close="handleClose"
                @save="handleSave"
                :disableSave="!cropping"
            >
                <dialog-button
                    @click="handleUpload"
                    :color="'secondary'"
                >
                    <i class="mr-1 fa-light fa-up-from-bracket fa-fw fa-lg"/>
                    <label :id="id" class="font-weight-regular">
                        <input type="file" accept="image/jpeg,image/png" name="file" class="hidden">
                        {{ tUploadImage }}
                    </label>
                </dialog-button>
            </dialog-actionbar>
        </v-card>
    </dialog-base>
</template>

<style>
.cropper img {
    display: block;
    max-width: 100%;
}
</style>
